import * as React from 'react';

import {SidebarUserAvatar} from 'shells/avatar/sidebar-user-avatar';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import type {GetSessionUser_loggedInUser as User} from 'nutshell-graphql-types';

import {getAgentIsOnline} from '../../../sidebar/helpers';

import styles from './user-menu-popover.module.css';

type Props = {
    user: User;
};

export const Header = (props: Props) => {
    return (
        <div className={styles.header}>
            <StackLegacy isHorizontal={true} spacing={16}>
                <SidebarUserAvatar
                    {...props.user}
                    isActive={false}
                    size={32}
                    isOnline={getAgentIsOnline(props.user)}
                />
                <StackLegacy spacing={0}>
                    <Body color='white'>{props.user.name}</Body>
                    <Body color='white' size='mini'>
                        {/* @ts-expect-error */}
                        {props.user.emailAddresses[0].address}
                    </Body>
                </StackLegacy>
            </StackLegacy>
        </div>
    );
};
